
export default {
  name: 'TimecardCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How do you calculate work hours worked online?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To calculate total hours worked an online base on the hourly rate, you will need to find the right support tool and do a few things below: Select the work start and end clock-out times in the main interface. Convert the appropriate time clock format. Convert the minutes to the proper form. Use the calculator's tool to subtract the end time from the start time. If the company has an exact working time policy, remove unpaid break deductions (lunch breaks)."
        }
      },{
        "@type": "Question",
        "name": "How do I calculate Timecards in Excel?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can do it manually and professionally to figure out timecards in Excel. With manual calculations, you will need to enter the start time and end time data into the spreadsheet. Then use a simple addition and subtraction formula to calculate hours. For the professional calculation method, you will need to format the data, use the Excel time function, and customize the total hours and minutes to get the most accurate results."
        }
      },{
        "@type": "Question",
        "name": "Can Google Sheets calculate the time clock?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can use Google Sheets to calculate the time. The formula you can use is \"=Hour(X).\" X is the location of the cell you want to extract the total hours from. When performing this calculation, the result ranges from 0 to 23."
        }
      },{
        "@type": "Question",
        "name": "How many types of Timecard calculators?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "There are many models of card calculators you can consider. Here are the three most common models and types: Electronic time and attendance card calculator: This will work on the website. Employees will use this tool to track their working time. The device includes some basic features, such as timers and reporting. Timekeeping application: Businesses with many employees need to install this tool on their computers to track their working hours. The software will store and send data from the Timecard to the management board. Manual timesheet calculator: This simple tool lets employees record their shift start and end times and then use the calculator to calculate their total weekly timecard hours."
        }
      },{
        "@type": "Question",
        "name": "How do you convert Timecards to regular hours?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To convert from time tags to hours, you can take the following manual steps: Re-statistical data and constant use of only 24-hour clock format. Subtract the start time from the end time. You will get the total daily working time with minute accuracy. Convert time to decimal format to facilitate the payroll process."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      days: [
	      {
	      	"name": "Monday"
	      },
	      {
	      	"name": "Tuesday"
	      },
	      {
	      	"name": "Wednesday"
	      },
	      {
	      	"name": "Thursday"
	      },
	      {
	      	"name": "Friday"
	      },
	      {
	      	"name": "Saturday"
	      },
	      {
	      	"name": "Sunday"
	      }
      ],
      form: this.$vform({
        inHour: ['8'],
        inMin: ['30'],
        inTime: ['am','am','am','am','am','am','am'],
        outHour: ['5'],
        outMin: ['00'],
        outTime: ['pm','pm','pm','pm','pm','pm','pm'],
        breakHour: ['00'],
        breakMin: ['30']
      })
    }
  },
  methods: {
    onTimecardCalculator() {
        this.form.post(`/tool/timecard-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
